<script setup lang="ts">
import ChapterHubPage from "~/features/computer/components/ChapterHubPage.vue";
</script>

<template>
  <ChapterHubPage unit="data-structures" />
</template>
